import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// HOCs
import withTitle from 'hocs/WithTitle';
// Models
import mWorkspace from 'models/cpm/workspace';
// Custom
import { fullListShape } from 'constants/PropTypesShapes';
import { MaxWidthContext } from 'components/misc/Contexts';
import {
  refreshList,
  openDialog,
  closeDialog,
  cpmListWorkspaces,
  cpmCreateWorkspace,
} from 'actions';
import MainListTemplate from 'components/templates/MainListTemplate';
import WorkspaceRow from 'cpmWorkspaces/assets/main/WorkspaceRow';
import WorkspaceFilters from 'cpmWorkspaces/assets/main/WorkspaceFilters';
import { AddContainedButton } from 'components/buttons/ContainedButtons';

class WorkspacesList extends React.Component {
  constructor(props) {
    super(props);

    this.handleAddWorkspace = this.handleAddWorkspace.bind(this);
    this.handleValidateAddWorkspace = this.handleValidateAddWorkspace.bind(this);
    this.doGetRowComp = this.doGetRowComp.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { workspaceCreated, handleRefreshList, handleCloseDialog } = this.props;
    const { workspaceCreated: prevWorkspaceCreated } = prevProps;

    // Catch operations success which need a refresh of the list
    if (!prevWorkspaceCreated && workspaceCreated) {
      handleRefreshList();

      // Close popup
      handleCloseDialog('WORKSPACE_ADD_EDIT');
    }
  }

  handleAddWorkspace() {
    const { handleOpenDialog } = this.props;

    handleOpenDialog({
      title: {
        id: 'title.addWorkspace',
      },
      actions: [{ type: 'cancel' }, { type: 'validate', preventClosing: true }],
      component: {
        type: 'WORKSPACE_ADD_EDIT',
        props: {
          onValidate: (data) => this.handleValidateAddWorkspace(data),
        },
      },
      dividers: true,
      size: 'md',
    });
  }

  handleValidateAddWorkspace(data) {
    const { handleAddWorkspace } = this.props;
    handleAddWorkspace(data);
  }

  doGetRowComp(props) {
    return <WorkspaceRow {...props} />;
  }

  render() {
    const contentMaxWidth = this.context;
    const { workspaces, handleListWorkspaces } = this.props;

    return (
      <div className="w-100 h-100 d-flex flex-column align-items-center justify-content-space-between" style={{ gap: '32px' }}>
        <MainListTemplate
          title={<LocalizedMessage id="title.workspacesList" />}
          icon={mWorkspace.icon}
          contentMaxWidth={contentMaxWidth}
          actionButtons={[
            <div key="btnAdd" style={{ marginTop: 8, marginRight: 8 }}>
              <AddContainedButton
                size="small"
                primary
                onClick={this.handleAddWorkspace}
              />
            </div>,
          ]}
          name={mWorkspace.name}
          listFeatures={mWorkspace.listFeatures}
          withActions
          nbActions={2}
          elementsData={{
            loading: workspaces.loading,
            elements: workspaces.elements,
            handleGetList: (p, s, f) => handleListWorkspaces(p, s, f),
          }}
          rowComp={this.doGetRowComp}
          filtersComp={<WorkspaceFilters />}
        />
      </div>
    );
  }
}

WorkspacesList.contextType = MaxWidthContext;

WorkspacesList.propTypes = {
  handleRefreshList: PropTypes.func.isRequired,
  handleCloseDialog: PropTypes.func.isRequired,
  handleOpenDialog: PropTypes.func.isRequired,
  handleListWorkspaces: PropTypes.func.isRequired,
  handleAddWorkspace: PropTypes.func.isRequired,
  workspaceCreated: PropTypes.bool.isRequired,
  workspaces: fullListShape.isRequired,
};

const mapStateToProps = (state) => ({
  workspaces: state.cpmWorkspace.list,
  workspaceCreated: state.cpmWorkspace.add.added,
});

const mapDispatchToProps = (dispatch) => ({
  handleOpenDialog: (props) => {
    dispatch(openDialog(props));
  },
  handleRefreshList: () => {
    dispatch(refreshList());
  },
  handleCloseDialog: (componentType) => {
    dispatch(closeDialog(componentType));
  },
  handleListWorkspaces: (pagination, sort, filters) => {
    dispatch(
      cpmListWorkspaces(mWorkspace.queListWorkspaces, {
        pagination,
        sort,
        filters,
      }),
    );
  },
  handleAddWorkspace: (data) => {
    dispatch(cpmCreateWorkspace(mWorkspace.mutCreateWorkspace, data));
  },
});

module.exports = compose(connect(mapStateToProps, mapDispatchToProps),
  withTitle('pageTitle.workspaces'))(WorkspacesList);



// WEBPACK FOOTER //
// ./routes/cpm/routes/workspaces/routes/list/components/WorkspacesList.js